// frontend/src/pages/Services/constants.js

export const BILLING_LABELS = {
  monthly:   'Месяц',
  annual:    'Год',
  perpetual: 'Бессрочно',
  one_time:  'Разовая',
};

export const ROLE_COLORS = {
  Admin:      'red',
  Member:     'blue',
  Guest:      'orange',
  Unlicensed: 'default',
};

export const LICENSE_TYPE_LABELS = {
  purchased: 'Купленная',
  grey:      'Грязный домен',
};


export const ALLOCATION_LABELS = {
  named_user:     'Персональные',
  shared_account: 'Общие на компанию',
  concurrent:     'Шареные лицензии',
};

export const ALLOCATION_COLORS = {
  named_user:     'blue',
  shared_account: 'cyan',
  concurrent:     'purple',
};

export const LICENSE_TYPE_COLORS = {
  purchased: 'blue',
  grey:      'orange',
};

export const PAYMENT_METHOD_LABELS = {
  card:    'Карта',
  invoice: 'Счёт',
};

export const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  RUB: '₽',
  RSD: 'дин',
};

export function formatDate(str) {
  if (!str) return '—';
  return new Date(str).toLocaleDateString('ru-RU');
}

export function daysUntil(dateStr) {
  if (!dateStr) return null;
  return Math.ceil((new Date(dateStr) - new Date()) / 86400000);
}

export function formatCost(price, total, currency) {
  if (!price || !total) return null;
  const sum = Number(price) * Number(total);
  const sym = CURRENCY_SYMBOLS[currency] || currency;
  return `${sum.toLocaleString('ru-RU')} ${sym}`;
}